/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalViewerViewModel } from "../types/PersonDocumentApprovalViewerViewModel.ts";
import { personDocumentApprovalDocumentViewModelSchema } from "./personDocumentApprovalDocumentViewModelSchema.ts";

export const personDocumentApprovalViewerViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula."),
  ),
  personId: z.optional(z.number().int().describe("ID da pessoa (aluno).")),
  code: z.string().describe("Código da pessoa.").nullish(),
  name: z.string().describe("Nome completo do aluno.").nullish(),
  email: z.string().describe("E-mail do aluno.").nullish(),
  firstName: z.string().describe("Primeiro nome cadastrado.").nullish(),
  lastName: z.string().describe("Sobrenome cadastrado.").nullish(),
  birthDateRG: z
    .string()
    .datetime()
    .describe("Data de nascimento. Opcional.")
    .nullish(),
  mothersName: z.string().describe("Nome completo da mãe. Opcional.").nullish(),
  gender: z
    .number()
    .int()
    .describe(
      "Gênero. Opcional. Enum EGender: `1` = Male, `2` = Female, `3` = IDontWantToAnswer.",
    )
    .nullish(),
  nationalityId: z
    .number()
    .int()
    .describe("ID da nacionalidade. Opcional.")
    .nullish(),
  birthCountryId: z
    .number()
    .int()
    .describe("ID do país de nascimento. Opcional.")
    .nullish(),
  birthStateId: z
    .number()
    .int()
    .describe("ID do estado de nascimento (nascidos no Brasil). Opcional.")
    .nullish(),
  birthState: z
    .string()
    .describe(
      "Estado de nascimento em texto livre (nascidos no exterior). Opcional.",
    )
    .nullish(),
  birthCityId: z
    .number()
    .int()
    .describe("ID da cidade de nascimento (nascidos no Brasil). Opcional.")
    .nullish(),
  birthCity: z
    .string()
    .describe(
      "Cidade de nascimento em texto livre (nascidos no exterior). Opcional.",
    )
    .nullish(),
  idCountryNumber: z
    .string()
    .describe("Número do documento de identidade estrangeiro. Opcional.")
    .nullish(),
  documentNumber: z.string().describe("Número do RG. Opcional.").nullish(),
  dispatchRGOrg: z
    .string()
    .describe("Órgão expedidor do RG. Opcional.")
    .nullish(),
  dispatchRGOrgState: z
    .string()
    .describe("UF do órgão expedidor do RG. Opcional.")
    .nullish(),
  dispatchRGDate: z
    .string()
    .datetime()
    .describe("Data de expedição do RG. Opcional.")
    .nullish(),
  isForeignDegree: z
    .boolean()
    .describe(
      "Indica se o diploma de graduação foi emitido fora do Brasil. Opcional.",
    )
    .nullish(),
  foreignStatus: z
    .number()
    .int()
    .describe(
      "Situação do diploma estrangeiro. Opcional. Enum EForeignStatus: `1` = Approved, `2` = PendingDocument, `3` = EquivalenceMade, `4` = Cancelled.",
    )
    .nullish(),
  verifiedDocumentData: z.optional(
    z
      .boolean()
      .describe("Indica se os dados documentais já foram verificados."),
  ),
  enrollmentStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status da matrícula. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
      ),
  ),
  enrollmentStatusText: z
    .string()
    .describe("Descrição do status da matrícula (pt-BR).")
    .nullish(),
  documentationStatus: z
    .number()
    .int()
    .describe(
      "Status geral da documentação. Opcional. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
    )
    .nullish(),
  classStudentText: z.string().describe("Descrição da turma.").nullish(),
  associatedCompanyName: z
    .string()
    .describe("Nome da empresa associada do aluno; vazio quando não há.")
    .nullish(),
  scholarshipType: z
    .string()
    .describe("Tipo de bolsa; nulo neste retorno. Opcional.")
    .nullish(),
  isIriCourse: z.optional(
    z.boolean().describe("Indica se a turma pertence a curso IRI."),
  ),
  hasPostGradDocument: z.optional(
    z.boolean().describe("Indica se o curso exige diploma de pós-graduação."),
  ),
  hasOtherDocuments: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o aluno possui documentos avulsos (abre o modal de outros documentos).",
      ),
  ),
  hasDocumentScanned: z.optional(
    z
      .boolean()
      .describe(
        "Indica se algum documento legível por OCR (RG, CPF ou Diploma de Pós) possui leitura persistida.",
      ),
  ),
  allowChangeStatus: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o status da matrícula pode ser alterado para Aprovado a partir da tela.",
      ),
  ),
  updateEnrollmentStatus: z.optional(
    z
      .boolean()
      .describe(
        "Estado inicial do checkbox de atualização do status da matrícula.",
      ),
  ),
  documentAnalysisStartTimeTicks: z.optional(
    z
      .number()
      .int()
      .describe(
        "Início da análise em Ticks UTC, gerado no servidor; devolver no PUT de salvamento para o cálculo da duração.",
      ),
  ),
  documentsOfCourse: z
    .array(z.lazy(() => personDocumentApprovalDocumentViewModelSchema))
    .describe(
      "Documentos exigidos pelo curso, na ordem de exibição RG, CPF, Diploma e demais.",
    )
    .nullish(),
}) as unknown as ToZod<PersonDocumentApprovalViewerViewModel>;
